import type { ComponentType } from '@grafikr/components';
import ShopSwitch from 'utils/shop-switch';

const component: ComponentType = (node) => {
  if (window.location.search.includes('?geo')) {
    localStorage.setItem('geo:dismissed', 'true');
  }

  const data = JSON.parse(node.querySelector('script').innerHTML);
  const { sites } = data;
  if (!sites.length) return;
  const shopSwitch = ShopSwitch(sites, node);

  const dismiss = node.querySelectorAll('[data-dismiss]');
  const switchToggles = document.querySelectorAll('[data-shop-switch]');
  const overlay = document.querySelector('.overlay');

  const languageListToggles = node.querySelectorAll('[data-toggle-languages]');
  const languageList: HTMLElement = node.querySelector('[data-language-list]');
  const flagElm: HTMLElement = node.querySelector('[data-flag]');
  const descriptionElm: HTMLElement = node.querySelector('[data-description]');
  const actionButtonsWrapper: HTMLElement = node.querySelector('[data-actions]');
  const redirectButton: HTMLElement = node.querySelector('[data-redirect]');

  dismiss.forEach((button) => {
    button.addEventListener('click', () => {
      shopSwitch.close();
    });
  });

  redirectButton.addEventListener('click', () => {
    shopSwitch.close();
    const checkedInput: HTMLElement = languageList.querySelector('input:checked');
    const selectedStore = sites.find((i) => i.code === checkedInput.dataset.code);
    if (selectedStore) {
      window.location.href = selectedStore.url;
    }
  });

  languageListToggles.forEach((button) => {
    button.addEventListener('click', () => {
      if (languageList.style.maxHeight) {
        languageList.style.maxHeight = `${languageList.scrollHeight}px`;
        setTimeout(() => {
          languageList.style.maxHeight = null;
        }, 5);

        actionButtonsWrapper.hidden = false;
      } else {
        const parentAccordion: HTMLElement =
          languageList.parentElement.closest('.accordion-content');

        if (parentAccordion) {
          parentAccordion.style.maxHeight = 'none';
        }
        actionButtonsWrapper.hidden = true;
        languageList.style.maxHeight = `${languageList.scrollHeight}px`;
      }

      if (button.hasAttribute('data-confirm')) {
        const checkedInput: HTMLElement = languageList.querySelector('input:checked');
        const selectedStore = sites.find((i) => i.code === checkedInput.dataset.code);
        if (selectedStore) {
          flagElm.innerHTML = `<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
               data-src="${selectedStore?.icon}"
               class="lazyload h-5 w-auto"
               alt="${selectedStore.name} icon">
          <span class="ml-2 text-xl">${selectedStore.name}</span>`;

          descriptionElm.innerHTML = selectedStore.description;
        }
      }
    });
  });

  if (overlay) {
    overlay.addEventListener('click', () => {
      shopSwitch.close();
    });
  }

  switchToggles.forEach((toggle) => {
    toggle.innerHTML = `<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                     data-src="${shopSwitch.currentShop?.icon}"
                     class="lazyload w-auto"
                     style="height:18px"
                     alt="${shopSwitch.currentShop?.name} icon"> 
                     <span class="text-lg underline">${shopSwitch.currentShop?.name}</span>`;
    toggle.classList.remove('animate-pulse');
    toggle.addEventListener('click', () => {
      shopSwitch.open();
    });
  });
};

export default component;
